import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3de8c22b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3de8c22b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8c22b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de8c22b')) {
      api.createRecord('3de8c22b', component.options)
    } else {
      api.reload('3de8c22b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3de8c22b&scoped=true&", function () {
      api.rerender('3de8c22b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwVideo/index.vue"
export default component.exports